module.exports = __webpack_public_path__ + "static/default-small-1f5182589c72257ddb89e09688b80df2.png";